import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './AddRideFare.css';
import getRideFareOptionsQuery from './getRideFareOptions.graphql';
import RideFareForm from '../../../../components/SiteAdmin/RideFare/RideFareForm';
import Loader from '../../../../components/Common/Loader/Loader';
import messages from '../../../../locale/messages';

class AddRideFare extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };

  static defaultProps = {
    fareOptions: {
      loading: true
    }
  };

  render() {
    const { fareOptions, fareOptions: { loading, getLocations, getActiveRideCategories } } = this.props;

    const categories = getActiveRideCategories && getActiveRideCategories.results;

    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={cx(s.heading, 'textAlignRightRTL')}>
              <FormattedMessage {...messages.addRideFare} />
            </div>
            <div className={s.paddingRoutesSection}>
              {
                !loading && <RideFareForm
                  locations={getLocations}
                  categories={categories}
                  initialValues={{
                    isActive: true,
                    isSurgePrice: false,
                    surgePricing: []
                  }}
                />
              }
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getRideFareOptionsQuery, {
    name: 'fareOptions',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  })
)(AddRideFare);
